import React, { useMemo } from "react";
import { MapContainer, TileLayer, Marker, Circle, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { useNavigate } from "react-router-dom";

function pinIcon(color) {
  return L.divIcon({
    className: "",
    html: `<div style="transform:translate(-50%,-100%)"><div style="width:28px;height:28px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:${color};box-shadow:0 2px 6px rgba(0,0,0,.3);border:2px solid #fff"></div></div>`,
    iconSize: [28, 28],
    iconAnchor: [0, 0],
  });
}
const CREATOR_ICON = pinIcon("#4f46e5");
const HOME_ICON = pinIcon("#059669");

function Recenter({ center, radius }) {
  const map = useMap();
  React.useEffect(() => {
    if (center && center[0] != null) {
      const zoom = radius ? (radius > 25 ? 9 : radius > 12 ? 10 : 11) : 10;
      map.setView(center, zoom);
    }
  }, [center, radius, map]);
  return null;
}

export function DiscoveryMap({ creators, center, radius, height = 340 }) {
  const navigate = useNavigate();
  const fallback = [51.4543, -0.9781]; // Reading
  const mapCenter = center && center[0] != null ? center : fallback;
  const points = useMemo(() => creators.filter((c) => c.lat != null && c.lng != null), [creators]);

  return (
    <div className="overflow-hidden rounded-2xl border border-zinc-200" style={{ height }} data-testid="discovery-map">
      <MapContainer center={mapCenter} zoom={10} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Recenter center={mapCenter} radius={center && center[0] != null ? radius : null} />
        {center && center[0] != null && radius ? (
          <Circle center={mapCenter} radius={radius * 1000} pathOptions={{ color: "#059669", fillColor: "#059669", fillOpacity: 0.08 }} />
        ) : null}
        {center && center[0] != null && (
          <Marker position={mapCenter} icon={HOME_ICON}>
            <Popup>Your search area</Popup>
          </Marker>
        )}
        {points.map((c) => (
          <Marker key={c.user_id} position={[c.lat, c.lng]} icon={CREATOR_ICON}>
            <Popup>
              <div className="text-center">
                <p className="font-semibold">{c.display_name}</p>
                <p className="text-xs text-zinc-500">{c.location}{c.distance_km != null ? ` · ${c.distance_km} km` : ""}</p>
                <button onClick={() => navigate(`/creators/${c.user_id}`)} className="mt-1 text-xs font-semibold text-emerald-600 underline">
                  View profile
                </button>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
